import {Person} from './person';
import {Model} from './model';

export class User implements Model {
  id: number;
  name: string;
  email: string;
  created_at: Date;
  updated_at: Date;
  person: Person;
  roles: Array<{ id: number; name: string }>;

  constructor(data?) {
    if (data != null) {
      this.fill(data);
    }
  }

  public fill(data) {
    this.id         = data['id'];
    this.name       = data['name'];
    this.email      = data['email'];
    this.created_at = data['created_at'];
    this.updated_at = data['updated_at'];
    this.person     = data['person'];
    this.roles      = data['roles'];
  }

  public serialize() {
    return this;
  }

}
